import {connect} from 'react-redux'
import styles from './ListRecipient.css'
import {onClickDelete} from 'actions/setting/emailNotification'

class ListRecipient extends React.Component {
  render () {
    let {settingAlertRecipients} = this.props
    return (
      <div>
        {settingAlertRecipients.map((recipient, idx) => {
          if (!recipient.is_added) {
            return <div />
          }
          return (
            <div className={idx !== 0 ? `row ${styles['box-recipient']}` : `row ${styles['box-recipient-disabled']}`}>
              <div className={idx === 0 ? `col-xs-6` : `col-xs-6 ${styles['list-email']}`}>
                {recipient.email}
              </div>
              <div className={idx === 0 ? `col-xs-4` : `col-xs-4 ${styles['list-status']}`}>
                {recipient.verified
                  ? <div className={styles['status-verified']}>
                    <i className={'fa fa-check-circle fa-lg fa-fw ' + styles['icon-verified']} />
                      Verified
                    </div>
                  : recipient.id && <div className={styles['status-waiting']}>
                      Waiting for Verification
                    </div>
                }
              </div>
              {(idx > 0) &&
                <div className={`col-xs-2 ${styles['btn-delete']}`}>
                  <button className='btn btn-danger' onClick={(event) => this._onClickDelete(event, recipient)}>
                    <i className='fa fa-trash' />
                  </button>
                </div>}
            </div>
          )
        })}
      </div>
    )
  }

  _onClickDelete = (event, deletedRecipient) => {
    event.stopPropagation()
    event.preventDefault()
    this.props.dispatch(onClickDelete(deletedRecipient))
  }
}

ListRecipient.propTypes = {
  settingAlertRecipients: React.PropTypes.object
}

function mapStateToProps (state) {
  return {
    data: state
  }
}

export default connect(mapStateToProps)(ListRecipient)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/ListRecipient/ListRecipient.js